export default function NotFound() {
  return <div>Ops! Essa página não existe.</div>;
}
